"use client";

import { useEffect } from "react";

import { APP_METADATA } from "@/app/(public)/_components/site-constants";

export function GtmAppMetadata() {
  useEffect(() => {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: "app_metadata_ready",
      appMetadata: APP_METADATA,
    });
  }, []);

  return null;
}
